export const SpeechRecognition =
  window['SpeechRecognition'] ||
  window['webkitSpeechRecognition'] ||
  window['mozSpeechRecognition'] ||
  window['msSpeechRecognition'];



// WEBPACK FOOTER //
// ./src/app/shared/voice-control/speech-recognition.api.ts